import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CatalogContext = createContext({ products: [], loading: true, reload: () => {} });

const imgUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const normalise = (p) => ({
    ...p,
    images: (p.images || []).map(imgUrl),
    image: imgUrl(p.image),
    gallery: (p.images || []).map(imgUrl),
    sizes: p.variants?.length
        ? p.variants.map((v) => ({ id: v.id, label: v.label, inr: v.sale_price ?? v.price, original: v.sale_price ? v.price : null, aed: v.aed, stock: v.stock }))
        : null,
    effectivePrice: p.sale_price ?? p.price,
    originalPrice: p.sale_price ? p.price : null,
});

export const CatalogProvider = ({ children }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const reload = () =>
        axios.get(`${API}/products`).then(({ data }) => setProducts(data.map(normalise))).catch(() => {}).finally(() => setLoading(false));
    useEffect(() => { reload(); }, []);
    return <CatalogContext.Provider value={{ products, loading, reload }}>{children}</CatalogContext.Provider>;
};

export const useCatalog = () => useContext(CatalogContext);
export const useProductsByCategory = (cat) => useCatalog().products.filter((p) => p.category === cat);
